import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';

import { ComponentLoader } from '../ComponentLoader/ComponentLoader';
import { fetchTradeOnboardingEligibility } from './fetchTradeOnboardingEligibility';

const importPdpTradeDesignManagerOnboardingCoachmark = () => {
    return import(/* webpackChunkName: "PdpRespTradeDesignManagerOnboardingCoachmark" */
    '../../pdp/PdpRespTradeDesignManagerOnboardingCoachmark/PdpRespTradeDesignManagerOnboardingCoachmark').then(
        moduleExport => moduleExport.PdpRespTradeDesignManagerOnboardingCoachmark
    );
};

const importPdpTradeOnboardingCoachmark = () => {
    return import(/* webpackChunkName: "PdpTradeOnboardingCoachmark" */
    '../../pdp/PdpRespTradeOnboardingCoachmark/PdpRespTradeOnboardingCoachmark').then(
        moduleExport => moduleExport.PdpRespTradeOnboardingCoachmark
    );
};

const importSbTradeOnboardingCoachmark = () => {
    return import(/* webpackChunkName: "SbTradeOnboardingCoachmark" */
    '../../finding/SbRespTradeOnboardingCoachmark/SbRespTradeOnboardingCoachmark').then(
        moduleExport => moduleExport.SbRespTradeOnboardingCoachmark
    );
};

export class TradeOnboardingCoachmarkConditionalLoaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.checkEligibility = this.checkEligibility.bind(this);
        this.getLoadFunc = this.getLoadFunc.bind(this);
        this.state = {
            eligibilityChecked: false,
            userEligibleForOboarding: false, // updated when relay prop received
        };
    }

    componentDidMount() {
        this.checkEligibility();
    }

    componentDidUpdate() {
        this.checkEligibility();
    }

    checkEligibility() {
        const { relay, user } = this.props;
        const { eligibilityChecked } = this.state;
        const relayEnvironment = get(relay, 'environment');
        const userId = get(user, 'serviceId');

        if (eligibilityChecked || !relayEnvironment || !userId) {
            return;
        }

        this.setState({ eligibilityChecked: true }, () => {
            fetchTradeOnboardingEligibility(relayEnvironment, userId).then(
                userEligibleForOboarding => {
                    this.setState({ userEligibleForOboarding });
                }
            );
        });
    }

    getLoadFunc() {
        const { isPdp, isSb, isDesignManager } = this.props;
        switch (true) {
            case isPdp:
                return importPdpTradeOnboardingCoachmark;
            case isSb:
                return importSbTradeOnboardingCoachmark;
            case isDesignManager:
                return importPdpTradeDesignManagerOnboardingCoachmark;
            default:
                return null;
        }
    }

    render() {
        const { item, showModal } = this.props;
        const { userEligibleForOboarding } = this.state;

        const loadFunc = this.getLoadFunc();

        if (!loadFunc) {
            console.warn(
                'cannot render onboarding coachmark because pdp/sb indicator not provided'
            );
            return null;
        }

        return (
            <ComponentLoader
                load={userEligibleForOboarding}
                importFunc={loadFunc}
                useLoadingComponent={false}
                itemId={get(item, 'serviceId')}
                showModal={showModal}
            />
        );
    }
}

TradeOnboardingCoachmarkConditionalLoaderComponent.propTypes = {
    isPdp: PropTypes.bool,
    isSb: PropTypes.bool,
    isDesignManager: PropTypes.bool,
    item: PropTypes.object,
    relay: PropTypes.object,
    showModal: PropTypes.bool,
    user: PropTypes.object,
};

export const TradeOnboardingCoachmarkConditionalLoader = createFragmentContainer(
    TradeOnboardingCoachmarkConditionalLoaderComponent,
    {
        item: graphql`
            fragment TradeOnboardingCoachmarkConditionalLoader_item on Item {
                serviceId
            }
        `,
        user: graphql`
            fragment TradeOnboardingCoachmarkConditionalLoader_user on User {
                serviceId
            }
        `,
    }
);
